import { APP_ENVIRONMENT } from '../../../../api/config';
export var convertCoreDocuments = function convertCoreDocuments(documents) {
  return documents.map(function (d) {
    var url = "".concat(APP_ENVIRONMENT.coreUrl).concat(d.path);
    d.url = url; // eslint-disable-line
    d.pdf_url = url; // eslint-disable-line
    d.thumbnail_url = url; // eslint-disable-line
    d.title = d.filename; // eslint-disable-line
    return d;
  });
};
//# sourceMappingURL=fileUploadUtils.js.map